// 所有字典状态存储
import { getDictFlattenList, queryCommonDictionary, querySystemDictList } from '@/api/dictionary/index'

const getDefaultState = () => {
	return {
		// 各类字典数据
		dictionaries: {
			projectType: [], // 项目类型字典
			constructionType: [], // 建设性质字典
			projectLevel: [], // 立项级别字典
			registerType: [], // 注册类型字典
			addressList: [], // 地区字典
			messagesTags: [], // 消息类型字典
			policyType: [], // 政策类型字典
			benefitsType: [], // 权益类型字典
			certType: [], // 证书类型字典
			economicNature: [], // 经济性质字典
			education: [], // 学历字典
			personnelMajor: [], // 人员专业字典
			projectCategory: [] // 工程类别字典
		}
	}
}
const state = getDefaultState()

const mutations = {
	SET_DICTIONARY: (state, { type, data }) => {
		state.dictionaries[type] = data
	}
}

const actions = {
	// 通用的字典加载方法
	loadDictionary({ commit, state }, { type, apiFunc, params = {} }) {
		return new Promise((resolve, reject) => {
			// 如果已加载且有数据，直接返回
			if (state.dictionaries[type].length > 0) {
				resolve(state.dictionaries[type])
				return
			}

			// 否则请求接口
			apiFunc(params)
				.then(response => {
					const { data } = response
					commit('SET_DICTIONARY', { type, data })
					resolve(data)
				})
				.catch(error => {
					reject(error)
				})
		})
	},

	// 获取证书类型字典
	getCertTypeDictList({ dispatch }) {
		return dispatch('loadDictionary', {
			type: 'certType',
			apiFunc: queryCommonDictionary,
			params: { dictionaryId: '1', cxType: '4' }
		})
	},

	// 获取学历字典
	getEducationDictList({ dispatch }) {
		return dispatch('loadDictionary', {
			type: 'education',
			apiFunc: queryCommonDictionary,
			params: { dictionaryId: '6', cxType: '3' }
		})
	},

	// 获取权益类型字典
	getBenefitsTypeDictList({ dispatch }) {
		return dispatch('loadDictionary', {
			type: 'benefitsType',
			apiFunc: querySystemDictList,
			params: { parentCode: 'MEMBER_BENEFIT' }
		})
	},

	// 获取政策类型字典
	getPolicyTypeDictList({ dispatch }) {
		return dispatch('loadDictionary', {
			type: 'policyType',
			apiFunc: querySystemDictList,
			params: { parentCode: 'POLICY_TYPE' }
		})
	},

	// 获取消息类型字典
	getMessagesTagsDictList({ dispatch }) {
		return dispatch('loadDictionary', {
			type: 'messagesTags',
			apiFunc: querySystemDictList,
			params: { parentCode: 'MSG_TAGS' }
		})
	},

	// 获取地区字典
	getAddressDictList({ dispatch }) {
		return dispatch('loadDictionary', {
			type: 'addressList',
			apiFunc: getDictFlattenList,
			params: { parentId: '3ab7d41d88bd458da622fb21e84ea5b3', level: 3 }
		})
	},

	// 获取注册类型字典
	getRegisterTypeDictList({ dispatch }) {
		return dispatch('loadDictionary', {
			type: 'registerType',
			apiFunc: querySystemDictList,
			params: { parentCode: 'REGISTER_TYPE_LEVEL' }
		})
	},

	// 获取立项级别字典
	getProjectLevelDictList({ dispatch }) {
		return dispatch('loadDictionary', {
			type: 'projectLevel',
			apiFunc: querySystemDictList,
			params: { parentCode: 'PROJECT_LEVEL_TYPE' }
		})
	},

	// 获取建设性质字典
	getConstructionTypeDictList({ dispatch }) {
		return dispatch('loadDictionary', {
			type: 'constructionType',
			apiFunc: querySystemDictList,
			params: { parentCode: 'CONSTRUCTION_TYPE' }
		})
	},

	// 获取项目类别字典
	getProjectTypeDictList({ dispatch }) {
		return dispatch('loadDictionary', {
			type: 'projectType',
			apiFunc: querySystemDictList,
			params: { parentCode: 'PROJECT_TYPE' }
		})
	},

	// 获取人员-证书类型
	getPersonnelMajorDictList({ dispatch }) {
		return dispatch('loadDictionary', {
			type: 'personnelMajor',
			apiFunc: querySystemDictList,
			params: { parentCode: 'REGISTER_TYPE_LEVEL' }
		})
	},

	// 获取工程类别
	getProjectCategoryDictList({ dispatch }) {
		return dispatch('loadDictionary', {
			type: 'projectCategory',
			apiFunc: querySystemDictList,
			params: { parentCode: 'PROJECT_TYPE' }
		})
	}
	// 这里可以添加其他字典的加载方法，如：
	// getEconomicNatureList({ dispatch }) { ... }
}

// 创建自动加载的getters（切记，这里的getter命名，与上面的actionName有关联关系，规则为`get${getterName}List`，勿要弄错，否则控制台会报错 acction无法找到）
const getters = {
	certTypeDict: (state, getters, rootState, rootGetters) => {
		// 这里不能直接调用actions，需要通过特殊处理
		return state.dictionaries.certType
	},
	economicNatureDict: state => state.dictionaries.economicNature,
	educationDict: state => state.dictionaries.education,
	personnelMajorDict: state => state.dictionaries.personnelMajor,
	benefitsTypeDict: state => state.dictionaries.benefitsType,
	policyTypeDict: state => state.dictionaries.policyType,
	messagesTagsDict: state => state.dictionaries.messagesTags,
	addressDict: state => state.dictionaries.addressList,
	registerTypeDict: state => state.dictionaries.registerType,
	projectLevelDict: state => state.dictionaries.projectLevel,
	constructionTypeDict: state => state.dictionaries.constructionType,
	projectTypeDict: state => state.dictionaries.projectType,
	projectCategoryDict: state => state.dictionaries.projectCategory
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
